import { Link } from "react-router";

import { buttonVariants } from "@/components/ui";

/**
 * Ruta que no existe.
 *
 * En una SPA esto solo se ve si el fallback de historial **sí** está bien
 * configurado: el CDN devolvió `index.html` y fue la aplicación la que decidió
 * que la ruta no existe. Si el fallback faltara, lo que se vería es el 404 del
 * CDN y esta pantalla nunca aparecería.
 */
export function NotFound() {
  return (
    <main className="bg-background grid min-h-dvh place-items-center p-6 text-center">
      <div>
        <p
          aria-hidden
          className="text-surface-raised font-mono text-[64px] leading-none font-medium"
        >
          404
        </p>
        <h1 className="mt-2 text-[22px] font-semibold">Esta página no existe</h1>
        <p className="text-muted-foreground mt-1.5 text-sm">
          Puede que el enlace esté mal, o que la hayan movido.
        </p>
        <Link to="/" className={buttonVariants({ className: "mt-5" })}>
          Volver al inicio
        </Link>
      </div>
    </main>
  );
}
